import { createDateInNorwegianTime as d } from '@/services/new-utils.ts';

export const JULY_2026_CAMPAIGN_END_DATE = d(2026, 8, 31, 12, 0);
